export default "__VITE_ASSET__60d576b5__"